import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("vyg_token", data.token);
      localStorage.setItem("vyg_admin_email", data.email);
      toast.success("Welcome back");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-noir px-4">
      <Helmet><title>Admin · Vyagram</title></Helmet>
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-parchment p-8 shadow-card" data-testid="admin-login">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-forest text-parchment"><Lock size={18}/></div>
        <h1 className="mt-5 text-center font-display text-3xl">Admin · Vyagram</h1>
        <p className="mt-1 text-center text-sm text-noir/60">Sign in to manage properties, reviews and bookings.</p>
        <div className="mt-6 space-y-3">
          <label className="block">
            <span className="text-[11px] uppercase tracking-wider text-amber">Email</span>
            <input required value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="mt-1 w-full rounded-lg border border-forest/20 bg-white px-4 py-3 focus:border-forest focus:outline-none" data-testid="admin-email"/>
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-wider text-amber">Password</span>
            <input required value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="mt-1 w-full rounded-lg border border-forest/20 bg-white px-4 py-3 focus:border-forest focus:outline-none" data-testid="admin-password"/>
          </label>
          <button disabled={loading} type="submit" className="vyg-cta w-full" data-testid="admin-submit">{loading ? "Signing in…" : "Sign in"}</button>
        </div>
      </form>
    </div>
  );
}
